import { ConfirmDialog } from '@/components/feedback/ConfirmDialog';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmDownloadDialog = ({ open, onClose, onConfirm }: Props) => {
  return (
    <ConfirmDialog
      ariaLabel="download-file"
      titleText="Are you sure you want to download?"
      innerText={
        <>
          If you&apos;re on a personal device, it&apos;s safest to view files
          within the security of GovernorHub. If this file contains personal
          data (for example, information about named pupils), downloading it
          onto a personal device may not comply with your school or trust&apos;s
          data protection policy.
        </>
      }
      confirmText="Download"
      open={open}
      onConfirm={() => {
        onConfirm();
        onClose();
      }}
      onClose={onClose}
    />
  );
};
